export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilisateur non trouvé"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fermer"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recherche"])}
}